import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  tableDesc: {
    fontSize: "16px",
    fontWeight: 400,
  },
}));
